import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const people = [
  { key: "partners", label: "Partners", line: "For the person who gets all of you.", query: "relationship=Girlfriend%20%2F%20Boyfriend", img: "shaadi-could-never", pos: "50% 30%" },
  { key: "siblings", label: "Siblings", line: "Same roots. Your own kind of chaos.", query: "relationship=Sibling" },
  { key: "grandparents", label: "Grandparents", line: "For the stories worth passing on.", query: "relationship=Grandfather", img: "original-gangster-grandfather", pos: "50% 55%" },
  { key: "friends", label: "Best friends", line: "For the stories only you two get.", query: "relationship=Best%20friend", img: "best-part-of-the-playlist", pos: "50% 42%" },
  { key: "parents", label: "Parents", line: "For everything they gave.", query: "relationship=Mother", img: "woman-who-loved-me", pos: "50% 88%" },
  { key: "milestones", label: "Weddings and milestones", line: "Weddings, anniversaries, farewells and every new chapter.", query: "occasion=Wedding" },
];
const Tile = ({ p }) => <Link to={`/create/new?${p.query}`} className={`people-tile ${p.img ? "has-photo" : "is-type"}`} data-testid={`made-for-${p.key}`}>
  <div className="people-visual">
    {p.img ? <img src={`/images/approved/${p.img}-640.webp`} srcSet={`/images/approved/${p.img}-640.webp 640w, /images/approved/${p.img}-960.webp 960w`} sizes="(max-width: 767px) 50vw, 30vw" loading="lazy" width="640" height="800" style={{ objectPosition: p.pos }} alt={`A Keepsake book made for ${p.label.toLowerCase()}`}/>
      : <h3 className="people-word">{p.label}</h3>}
  </div>
  <div className="people-caption"><div>{p.img && <h3>{p.label}</h3>}<p>{p.line}</p></div><ArrowUpRight size={20} strokeWidth={1.5}/></div>
</Link>;
export const MadeFor = () => <section id="made-for" className="people-section" aria-labelledby="made-for-title" data-testid="made-for-section">
  <div className="brand-container">
    <div className="people-head">
      <h2 id="made-for-title" className="display-l">Made for <em>your people.</em></h2>
      <p className="lede">Pick who it’s for. We’ll start the book there.</p>
    </div>
    <div className="people-grid">{people.map((p) => <Tile key={p.key} p={p}/>)}</div>
  </div>
</section>;
